<template>
  <div class="message-template columns is-mobile is-flex" :class="messageStyleClass">
    <div class="column content-column">
      <slot class="slot"></slot>
      <span class="message-time">{{formattedTime}}</span>
    </div>
    <div class="column photo-column is-narrow">
      <img
        v-if="direction === 'outgoing'"
        class="user-circular-icon"
        alt="bot placeholder image"
        src="@/assets/images/bot_placeholder.png"
      />
      <img
        v-if="direction === 'incoming' && image"
        class="user-circular-icon"
        alt="user placeholder image"
        :src="image"
      />
      <img
        v-else-if="direction === 'incoming'"
        class="user-circular-icon"
        alt="user placeholder image"
        src="@/assets/images/user_placeholder.png"
      />
    </div>
    <div class="column space-column is-2 is-hidden-touch">&nbsp;</div>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  name: 'messageTemplate',
  props: {
    time: {
      type: Number,
      default: 0,
    },
    direction: {
      type: String,
      default: '',
    },
    channel: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
  },
  mounted() {},
  computed: {
    formattedTime() {
      if (this.time) {
        return moment(this.time, 'x').format('h:mm A');
      }
      return '--:--';
    },
    messageStyleClass() {
      return {
        'incoming-block': this.direction === 'incoming',
        'outgoing-block': this.direction === 'outgoing',
        'line-style': this.direction === 'outgoing' && this.channel === 'line',
        'facebook-style': this.channel === 'facebook',
      };
    },
    userImage() {
      if (this.image) {
        return this.image;
      }
      return '../assets/images/user_placeholder.png';
    },
  },
};
</script>
<style lang="scss" scoped>
.message-template {
  margin: 10px 10px 0 10px;
  padding-bottom: 10px;
  font-size: 0.9rem;
  .user-circular-icon {
    background-color: #fff;
    border-radius: 100px;
    height: 32px;
    width: 32px;
    border: 1px solid #ddd;
  }
  .content-column {
    padding: 12px 0;
    display: flex;
    overflow: hidden;
  }
  .message-time {
    white-space: nowrap;
    font-size: 0.7rem;
    align-self: flex-end;
  }
  .space-column {
    flex-grow: 0.5;
    flex-shrink: 1;
    min-width: 60px;
  }
  .photo-column {
    flex-grow: 0;
    min-width: 60px;
  }
  &.incoming-block {
    .content-column {
      order: 2;
      justify-content: flex-start;
      .message-time {
        order: 1;
        margin-left: 10px;
      }
    }
    .photo-column {
      order: 1;
    }
    .space-column {
      order: 3;
    }
  }
  &.outgoing-block {
    .content-column {
      order: 2;
      justify-content: flex-end;
      .message-time {
        order: -1;
        margin-right: 10px;
      }
    }
    .photo-column {
      order: 3;
    }
    .space-column {
      order: 1;
    }
  }
}
</style>
